import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Map } from 'immutable';
import appConfig from '../../appConfig';
import { validateSessionConnection } from '../../actions/session';
import {
  cancelAllRequests,
  createCategory,
  deleteCategory,
  editCategory,
  retrieveCategories,
  clearPanelTreeList,
  toggleCollectionCollapse,
} from '../../actions/categories';
import { retrieveCategory, retrieveSortUMOs } from '../../actions/umoGallery';
import { showCategoryMoveDialog, toggleUMOSortView } from '../../actions/mainUI';
import PanelTree from '../PanelTree';
import CategoryDialog from '../CategoryDialog';
import { stringifiedToDraggable } from '../../utils/draggables';
import { isWorkbench } from '../../utils/piction';
import { showUploadTemplate } from '../../utils/uiUtils';
import { moveUmoHandler } from '../../utils/umoUtils';

const mapStateToProps = state => ({
  categories: state.categories,
  session: state.session,
});

const mapDispatchToProps = (dispatch, state) => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  onCategoryClick: (categoryID, label, description, search) =>
    dispatch(retrieveCategory(categoryID, label, description, search)),
  onEditSubmit: (categoryID, categoryName) =>
    dispatch(editCategory(categoryID, categoryName)),
  onCreateSubmit: (categoryParentID, categoryName) =>
    dispatch(createCategory(categoryName, categoryParentID)),
  onShowUploadTemplate: (categoryID, categoryName) =>
      showUploadTemplate(dispatch, categoryID, categoryName),
  onDeleteSubmit: categoryID => dispatch(deleteCategory(categoryID)),
  retrieveCategories: categoryID => dispatch(retrieveCategories(categoryID)),
  clearPanelTreeList: categoryID => dispatch(clearPanelTreeList(categoryID)),
  toggleCollectionCollapse: collID => dispatch(toggleCollectionCollapse(collID)),
  cancelAllRequests: () => dispatch(cancelAllRequests()),
  showCategoryMoveDialog: (categoryID, categoryName) =>
    dispatch(showCategoryMoveDialog(categoryID, categoryName)),
  validateSession: surl => dispatch(validateSessionConnection(surl)),
  toggleUMOSort: (categoryID, categoryName) => {
    dispatch(retrieveSortUMOs(categoryID, categoryName));
    dispatch(toggleUMOSortView(true));
  },
});

class NavCategoryPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCategoryDialogShown: false,
      isEdit: false,
      selectedCategoryData: null,
    };

    this.onEditSelect = this.onEditSelect.bind(this);
    this.onCategoryDialogToggle = this.onCategoryDialogToggle.bind(this);
    this.onCategoryCreateClick = this.onCategoryCreateClick.bind(this);
    this.onPanelItemDrop = this.onPanelItemDrop.bind(this);
    this.getCategoryOptions = this.getCategoryOptions.bind(this);
  }

  componentDidMount() {
    // this.props.retrieveCategories();
    if (this.props.categories.get('categoryList').size === 0) this.props.retrieveCategories();
  }

  componentWillUnmount() {
    this.props.cancelAllRequests();
  }

  onEditSelect(key, workspaceID, workspaceName) {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        switch (key) {
          case 'edit':
            this.setState({
              isCategoryDialogShown: true,
              isEdit: true,
              selectedCategoryData: {
                id: workspaceID,
                name: workspaceName,
              },
            });
            break;
          case 'subCategory':
            this.onCategoryCreateClick(null, workspaceID, workspaceName);
            break;
          case 'upload':
            this.props.onShowUploadTemplate(workspaceID, workspaceName);
            break;
          case 'move':
            this.props.showCategoryMoveDialog(workspaceID, workspaceName);
            break;
          case 'sort':
            this.props.toggleUMOSort(workspaceID, workspaceName);
            break;
          default:
            break;
        }
      }
      return null;
    });
  }

  onCategoryDialogToggle(toggle) {
    this.setState({
      isCategoryDialogShown: toggle,
    });
  }

  onCategoryCreateClick(e, categoryParentID, categoryName, categorySearch) {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        this.setState({
          isCategoryDialogShown: true,
          isEdit: false,
          selectedCategoryData: categoryParentID ? {
            id: categoryParentID,
            name: categoryName,
            search: categorySearch,
          } : null,
        });
      }
    });
  }

  onPanelItemDrop(e, categoryID, isCopy, isEditable) {
    e.preventDefault();
    $('.main__search-bar').removeAttr('style');
    const draggable = stringifiedToDraggable(e.dataTransfer.getData('text'));
    const origin = {
      id: draggable.originData.workspaceID,
      isWorkspace: draggable.isWorkspaceItem(),
    };
    const target = {
      id: categoryID,
      isWorkspace: false,
      editable: isEditable,
    };
    moveUmoHandler(origin, target, draggable.getSelectionList(), this.props.dispatch,
      draggable.getIsSelectAll() ? draggable.getSearchParams() : null, isCopy);
  }

  getCategoryOptions() {
    let editOptions;
    const intl = this.props.intl;
    if (appConfig.menuOptions.categorySpannerMenu) {
      if (appConfig.menuOptions.categorySpannerMenu.length > 0) {
        const menuOptions = appConfig.menuOptions.categorySpannerMenu;
        editOptions = [];
        menuOptions.forEach((value) => {
          switch (value) {
            case 'subCategory':
              editOptions.push({ eventKey: 'subCategory', label: intl.formatMessage({ id: 'navCategoryPanel.menuAddChild' }) });
              break;
            case 'upload':
              editOptions.push({ eventKey: 'upload', label: intl.formatMessage({ id: 'navCategoryPanel.menuUploadToChild' }) });
              break;
            case 'edit':
              editOptions.push({ eventKey: 'edit', label: intl.formatMessage({ id: 'navCategoryPanel.menuEditChild' }) });
              break;
            case 'move':
              editOptions.push({ eventKey: 'move', label: intl.formatMessage({ id: 'navCategoryPanel.menuMoveChild' }) });
              break;
            case 'sort':
              editOptions.push({ eventKey: 'sort', label: intl.formatMessage({ id: 'navCategoryPanel.menuSortChild' }) });
              break;
            default:
              break;
          }
        });
      }
    } else if (isWorkbench()) {
      // backwards support for appConfigs without the new definition
      editOptions = [
        { eventKey: 'subCategory', label: intl.formatMessage({ id: 'navCategoryPanel.menuAddChild' }) },
        { eventKey: 'upload', label: intl.formatMessage({ id: 'navCategoryPanel.menuUploadToChild' }) },
        { eventKey: 'edit', label: intl.formatMessage({ id: 'navCategoryPanel.menuEditChild' }) },
        { eventKey: 'move', label: intl.formatMessage({ id: 'navCategoryPanel.menuMoveChild' }) },
      ];
      if (appConfig.enableSortCategory) editOptions.push({ eventKey: 'sort', label: intl.formatMessage({ id: 'navCategoryPanel.menuSortChild' }) });
    }
    return editOptions;
  }

  render() {
    const editOptions = this.getCategoryOptions();
    return (
      <div className="nav-content__body">
        <h2
          className={cn(
            'nav-content__title',
            { 'nav-content__title--with-sub': isWorkbench() }
          )}
        >{this.props.intl.formatMessage({ id: 'navCategoryPanel.categoryHeader' })}</h2>

        <PanelTree
          onPanelItemClick={this.props.onCategoryClick}
          onPanelItemDrop={
            isWorkbench() ? this.onPanelItemDrop : undefined
          }
          retrievePanelTreeList={this.props.retrieveCategories}
          panelTreeList={this.props.categories.get('categoryList')}
          retrieveChildrenRequests={this.props.categories.get('retrieveChildrenRequests')}
          clearPanelTreeList={this.props.clearPanelTreeList}
          toggleCollectionCollapse={this.props.toggleCollectionCollapse}
          onEditSelect={isWorkbench() ? this.onEditSelect : undefined}
          editOptions={editOptions}
          isRoot
          isRetrievingRoot={this.props.categories.get('isRetrievingRoot')}
          showContentCount={appConfig.categoryCounts}
        />
        <CategoryDialog
          isCategoryDialogShown={this.state.isCategoryDialogShown}
          onCategoryDialogToggle={this.onCategoryDialogToggle}
          selectedCategoryData={this.state.selectedCategoryData}
          isEdit={this.state.isEdit}
          editRequests={this.props.categories.get('editRequests')}
          createRequests={this.props.categories.get('createRequests')}
          onEditSubmit={this.props.onEditSubmit}
          onCreateSubmit={this.props.onCreateSubmit}
          onDeleteSubmit={this.props.onDeleteSubmit}
        />
      </div>
    );
  }
}

NavCategoryPanel.propTypes = {
  cancelAllRequests: PropTypes.func,
  categories: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  onCategoryClick: PropTypes.func,
  retrieveCategories: PropTypes.func,
  clearPanelTreeList: PropTypes.func,
  toggleCollectionCollapse: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  showCategoryMoveDialog: PropTypes.func,
  onShowUploadTemplate: PropTypes.func,
  validateSession: PropTypes.func,
  dispatch: PropTypes.func,
  toggleUMOSort: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(NavCategoryPanel));



// WEBPACK FOOTER //
// ./src/js/components/NavCategoryPanel/index.jsx